var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty"},[_c('div',{staticClass:"empty__wrapper"},[_c('div',{staticClass:"empty__icon mb-2",domProps:{"innerHTML":_vm._s(_vm.icon)}}),_c('div',{staticClass:"empty__content"},[_c('p',{staticClass:"feta ekas mb-1"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"mozzarella anie"},[_vm._v(_vm._s(_vm.details))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }